import styled from "styled-components";

export const StyleAccountNavigation = styled.aside`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #07191f;

  nav {
    display: grid;
    padding: 8px 0;
  }

  .account-nav-link {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 54px;
    border: 0;
    padding: 0 26px;
    color: #ffffff;
    background: transparent;
    font: inherit;
    font-size: 15px;
    line-height: 1.2;
    font-weight: 700;
    text-align: left;
    cursor: pointer;
    transition:
      background 160ms ease,
      color 160ms ease;
  }

  .account-nav-link::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: transparent;
  }

  .account-nav-link:hover,
  .account-nav-link.active {
    background: #3d5f6e;
  }

  .account-nav-link.active::before {
    background: #ffffff;
  }

  .account-nav-link.logout {
    color: #ffc7c7;
  }

  .account-nav-link.wallet {
    color: var(--crypto-green);
  }

  .account-nav-link.wallet::after {
    content: "입출금";
    margin-left: auto;
    border-radius: 999px;
    padding: 4px 8px;
    color: #06110b;
    background: var(--crypto-green);
    font-size: 11px;
    line-height: 1;
    font-weight: 700;
  }

  @media (min-width: 800px) {
    width: 210px;
    flex: 0 0 210px;
    position: sticky;
    top: 86px;
    align-self: flex-start;
  }
`;
